export {
  GoogleTagManagerScript,
  GoogleTagManagerNoScript,
} from './google-tag-manager';
